import React from 'react'
import PropTypes from 'prop-types'
import InputMask from 'react-input-mask';

import TextField from './TextField'

function MaskedField({ mask, value, onChange, error, maskOptions, ...rest }) {

  const handleChange = evt => {
    let v = (evt.target.value || '').replace(/[^0-9]/g, '')

    onChange(v)
  }

  return (
    <InputMask
      mask={mask}
      value={value}
      onChange={handleChange}
      {...maskOptions}
    >
      {inputProps => (
        <TextField
          error={error}
          {...inputProps}
          {...rest}
        />
      )}
    </InputMask>
  )
}

MaskedField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  error: PropTypes.bool,
  maskOptions: PropTypes.object
}

MaskedField.defaultProps = {
  value: '',
  onChange: () => true,
  error: false,
  maskOptions: {}
}

export default MaskedField